<!--企业招聘-->
<template>
  <div class="recruit-container" @click="hidePopover">
    <header-index/>
    <div class="recruit-content" :style="'min-height:'+min_height+'px;'">
      <div class="recruit-top">
        <h1 class="recruit-top-title">人才招聘</h1>
        <el-input placeholder="请输入企业名称、职位名称" v-model="keyword" @keyup.enter.native="getJobSearchList"
                  class="input-with-select" style="width: 45%;">
          <el-button type="danger" slot="append" @click="getJobSearchList">查一下</el-button>
        </el-input>
      </div>
      <div class="recruit-screen">
        <el-row>
          <el-col :span="8" ref="firstCol">
            <el-popover placement="bottom-start" v-model="visible" trigger="manual" popper-class="popper-recruit">
              <el-button @click="changeRecruit">不限</el-button>
              <el-cascader-panel :options="jobList" v-model="recruit" @change="handleChange"></el-cascader-panel>
              <el-button slot="reference" type="text" :style="'color: #333333;width:'+bWidth+'px;'"
                         @click.stop="visibleRecruit(1)">
                {{ position.name.length > 0 ? position.name.join('/') : '职位' }}
                <i :class="!visible ? 'el-icon-caret-bottom el-icon--right' : 'el-icon-caret-top el-icon--right'"/>
              </el-button>
            </el-popover>
          </el-col>
          <el-col :span="8">
            <el-popover placement="bottom-start" v-model="visible2" trigger="manual" popper-class="popper-recruit">
              <el-radio-group v-model="expectedSalary" @change="visible2=false">
                <el-radio-button v-for="list of ExpectedSalaryList" :label="list.value">{{ list.name }}
                </el-radio-button>
              </el-radio-group>
              <el-button slot="reference" type="text" @click.stop="visibleRecruit(2)"
                         :style="'color: #333333;width:'+bWidth+'px;border-right:2px solid #C9CCDF;border-left:2px solid #C9CCDF;'">
                <span>{{ expectedSalary ? expectedSalary : '薪资' }}</span>
                <i :class="!visible2 ? 'el-icon-caret-bottom el-icon--right' : 'el-icon-caret-top el-icon--right'"/>
              </el-button>
            </el-popover>
          </el-col>
          <el-col :span="8">
            <el-popover placement="bottom-end" trigger="manual" popper-class="popper-recruit" v-model="visible3">
              <p style="padding-left: 10px;">学历要求</p>
              <el-radio-group v-model="education">
                <el-radio-button v-for="item of educationItem" :label="item.value">{{ item.name ? item.name : '不限' }}
                </el-radio-button>
              </el-radio-group>
              <p style="padding-left: 10px;">经验要求</p>
              <el-radio-group v-model="workingYears">
                <el-radio-button v-for="item2 of experience" :label="item2.value">{{ item2.name ? item2.name : '不限' }}
                </el-radio-button>
              </el-radio-group>
              <div class="bottom-btn">
                <el-button style="width: 50%;" plain @click="reset">重置</el-button>
                <el-button type="danger" style="width: 50%;" @click="submitSearch">确定</el-button>
              </div>
              <el-button slot="reference" type="text" @click.stop="visibleRecruit(3)"
                         :style="'color: #333333;width:'+bWidth+'px;'">
                <span>筛选</span>
                <i :class="!visible3 ? 'el-icon-caret-bottom el-icon--right' : 'el-icon-caret-top el-icon--right'"/>
              </el-button>
            </el-popover>
          </el-col>
        </el-row>
      </div>
      <div class="recruit-table" v-if="JobSearchList.length>0">
        <el-row :gutter="16">
          <el-col :span="8" v-for="list2 of JobSearchList">
            <div class="table-group" @click="positionDetails(list2)">
              <div class="table-header">
                <div class="table-group-th">
                  <span class="bold-span">{{ list2.name }}</span>
                  <span class="red-span" v-if="list2.negotiable!=1">{{ list2.salary }}</span>
                  <span class="red-span" v-else>薪资面议</span>
                </div>
                <div class="table-group-td">
                  <span class="normal-span">{{ list2.workArea }}</span>
                  <el-divider direction="vertical"/>
                  <span class="normal-span">{{ list2.workingYears }}</span>
                  <el-divider direction="vertical"/>
                  <span class="normal-span">{{ list2.education }}</span>
                </div>
              </div>
              <div class="table-bottom">
                <p class="companyName">{{ list2.companyName }}</p>
                <p class="vertical">
                  <span class="normal-span">{{ list2.businessNature }}</span>
                  <span class="normal-span" v-if="list2.companyScale"><el-divider
                      direction="vertical"/>{{ list2.companyScale }}</span>
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 分页 -->
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
      <div v-else>
        <el-empty description="暂无招聘信息"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import {jobThreeClassification, yqzdExpectedSalary, yqzdJobSearchList} from '@/api/recruitApi'
import cityJson from "@/static/cityJson.json";
import page from "@/components/page/pages";

export default {
  name: "index",
  components: {headerIndex, home_footer, Hang, page},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 315,
      keyword: '',
      jobList: [],
      ExpectedSalaryList: [{name: '不限', value: ''}],
      position: {
        name: [],
        value: [],
      },
      expectedSalary: '',
      visible: false,
      visible2: false,
      visible3: false,
      bWidth: 'auto',
      education: '',
      workingYears: '',
      educationItem: [
        {name: '不限', value: ''},
        {name: '初中', value: '初中'},
        {name: '高中', value: '高中'},
        {name: '大专', value: '大专'},
        {name: '本科', value: '本科'},
        {name: '硕士', value: '硕士'},
        {name: '博士', value: '博士'}
      ],
      experience: [
        {name: '不限', value: ''},
        {name: '应届生', value: '应届生'},
        {name: '1-3年', value: '1-3年'},
        {name: '2-4年', value: '2-4年'},
        {name: '3-5年', value: '3-5年'},
        {name: '4-6年', value: '4-6年'},
        {name: '5-7年', value: '5-7年'},
        {name: '6-8年', value: '6-8年'},
        {name: '7-9年', value: '7-9年'},
        {name: '8-10年', value: '8-10年'},
        {name: '10年以上', value: '10年以上'}
      ],
      JobSearchList: [],
      cityList: {},
      cid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 9,
        total: 0,
      },
      recruit: [],
      pName:'',
    }
  },
  watch: {
    expectedSalary(val) {
      this.getJobSearchList();
    }
  },
  methods: {
    /*职位分类三级列表*/
    getJobThreeClassification() {
      jobThreeClassification().then(res => {
        if (res.code == 200) {
          this.jobList = res.content.list;
        }
      })
    },
    /*获取期望薪资/薪资范围*/
    getExpectedSalary() {
      yqzdExpectedSalary().then(res => {
        if (res.code == 200) {
          for (let list of res.content) {
            this.ExpectedSalaryList.push({name: list.label, value: list.label});
          }
        }
      })
    },
    /*监听职位变更*/
    handleChange(value) {
      if (value.length > 2) {
        this.position = {name: [], value: []};
        this.position.value = value;
        for (let job of this.jobList) {
          if (job.value == value[0]) {
            this.position.name.push(job.label);
            for (let sub of job.children) {
              if (sub.value == value[1]) {
                this.position.name.push(sub.label);
                for (let s of sub.children) {
                  if (s.value == value[2]) {
                    this.position.name.push(s.label);
                  }
                }
              }
            }
          }
        }
        this.visible = false;
        this.getJobSearchList();
      }
    },
    /*招聘--搜索列表*/
    getJobSearchList() {
      yqzdJobSearchList({
        cityCode: 0,
        districtCode: 0,
        education: this.education,
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        provinceCode: this.cityList.id,
        recruitId: this.position.value[2],
        salary: this.expectedSalary,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        workingYears: this.workingYears
      }).then(res => {
        if (res.code == 200) {
          this.JobSearchList = res.content.rows;
          this.tablePage.total = res.content.total;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getJobSearchList();
    },
    /*重置选项*/
    reset() {
      this.education = '';
      this.workingYears = '';
    },
    /*提交筛选*/
    submitSearch() {
      this.visible3 = false;
      this.getJobSearchList();
    },
    /*隐藏对话框*/
    hidePopover() {
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
    },
    /*对话框的显示隐藏*/
    visibleRecruit(index) {
      if (index == 1) {
        this.visible = true;
        this.visible2 = false;
        this.visible3 = false;
      } else if (index == 2) {
        this.visible = false;
        this.visible2 = true;
        this.visible3 = false;
      } else if (index == 3) {
        this.visible = false;
        this.visible2 = false;
        this.visible3 = true;
      }
    },
    /*切换职位*/
    changeRecruit() {
      this.position = {name: [], value: []};
      this.visible = false;
      this.recruit = [];
      this.getJobSearchList();
    },
    /*职位详情*/
    positionDetails(list) {
      this.$router.replace({path: '/recruit/positionDetails', query: {id: list.id,pName:this.pName,}})
    }
  },
  mounted() {
    this.getJobThreeClassification();
    this.getExpectedSalary();
    this.getJobSearchList();
    this.bWidth = this.$refs.firstCol.$el.clientWidth;
  },
  beforeMount() {
    this.pName=this.$route.query.pName;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.recruit-container >>> .recruit-content .recruit-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.recruit-container >>> input::-webkit-input-placeholder {
  color: #333333;
}

.recruit-container >>> .recruit-content .recruit-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.recruit-container >>> .recruit-content .recruit-top .el-icon-search {
  font-size: 19px;
}

.recruit-container >>> .recruit-content .recruit-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.recruit-container >>> .recruit-content .recruit-screen .el-col-8 {
  width: 33.33333%;
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: center;
}

.popper-recruit .el-popover {
  border: none;
}

.popper-recruit .el-cascader-panel.is-bordered {
  border: none;
}
</style>
<style scoped lang="scss">
.recruit-container {
  background: #E7E9F5;

  .recruit-content {
    background: #E7E9F5;
    .recruit-top {
      background: url("~@/assets/img/recruit/recruit.png") no-repeat;
      background-size: 100% 100%;
      height: 400px;
      display: flow-root;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0px 18%;
      min-width: 76rem;
      .recruit-top-title {
        color: #ffffff;
        margin: 100px 0 60px;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
      }
    }

    .recruit-screen {
      padding: 20px 18%;
      min-width: 76rem;
    }

    .recruit-table {
      margin: 0px 18% 10px;
      min-width: 76rem;
      .table-group {
        background: #ffffff;
        padding: 20px;
        margin-bottom: 20px;

        .table-header {
          border-bottom: 1px solid #E7E9F5;

          .table-group-th {
            display: flex;
            justify-content: space-between;

            .bold-span {
              color: #333333;
              font-size: 18px;
              font-weight: bold;
              font-family: 'SourceHanSansCN';
            }

            .red-span {
              color: #FE273B;
              font-size: 18px;
              font-family: 'SourceHanSansCN';
            }
          }

          .table-group-td {
            line-height: 45px;

            .el-divider {
              background-color: #999999;
            }

            .normal-span {
              color: #333333;
              font-family: 'SourceHanSansCN';
              font-size: 14px;
            }
          }
        }

        .table-bottom {
          .companyName {
            margin-block-start: 20px;
            margin-block-end: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;
          }
          .vertical{
            margin-block-start: 0px;
            margin-block-end: 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
            word-break: break-all;
          }
          .el-divider {
            background-color: #999999;
          }

          .normal-span {
            color: #666666;
            font-family: 'SourceHanSansCN';
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
<style>
.popper-recruit .el-radio-button {
  margin: 0px 10px 20px;
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  min-width: 100px;
  text-align: center;
}

.popper-recruit .el-radio-group {
  max-width: 488px;
}

.popper-recruit .el-radio-group .el-radio-button__inner {
  font-weight: 100;
  color: #333333;
  padding: 12px 20px;
  font-size: 14px;
  min-width: 100px;
  border-radius: 4px;
  background: center;
  border: none;
  font-family: 'SourceHanSansCN';
}

.popper-recruit .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF !important;
  background-color: #FE273B !important;
  border-color: #FE273B !important;
  min-width: 100px;
  -webkit-box-shadow: 0px 0 0 0 #409eff;
  box-shadow: 0px 0 0 0 #409eff;
}

.popper-recruit .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
  color: #FE273B;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
  min-width: 100px;
}

.popper-recruit .bottom-btn .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  font-size: 14px;
  border-radius: 0px;
  margin-left: 0px;
}

.popper-recruit .bottom-btn .el-button--default {
  color: #666666;
  background-color: #ffffff;
  border-color: #E7E9F5;
  font-size: 14px;
  border-radius: 0px;
  margin-left: 0px;
}
</style>